import { render, staticRenderFns } from "./EmpresaDetalle.vue?vue&type=template&id=b110febe"
import script from "./EmpresaDetalle.vue?vue&type=script&lang=js"
export * from "./EmpresaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports